import { createContext, Dispatch, SetStateAction } from 'react';

export type DisableBlockerValues = {
  disableBlocker: boolean;
  setDisableBlocker: Dispatch<SetStateAction<boolean>>;
};

const DisableBlockerContext = createContext<DisableBlockerValues>({
  disableBlocker: false,
  setDisableBlocker: () => void 0,
});

export default DisableBlockerContext;
